import { jsx, jsxs } from 'react/jsx-runtime';
import { Loader } from '@phx-husky/loader';
import { forwardRef } from 'react';
import { Button } from '@phx-husky/button-auth';
import { Modal } from '@phx-husky/modal';
import { Typography } from '@phx-husky/typography-auth';

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1 = ".container-with-loader-module_loaderContainer__i9sSF {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbnRhaW5lci13aXRoLWxvYWRlci5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGFBQWE7RUFDYixtQkFBbUI7RUFDbkIsc0JBQXNCO0FBQ3hCIiwiZmlsZSI6ImNvbnRhaW5lci13aXRoLWxvYWRlci5tb2R1bGUuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5sb2FkZXJDb250YWluZXIge1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xufSJdfQ== */";
var styles$1 = {"loaderContainer":"container-with-loader-module_loaderContainer__i9sSF"};
styleInject(css_248z$1);

const ContainerWithLoader = forwardRef((_a, ref) => {
    var { children, showLoader, className, loaderProps } = _a, htmlProperties = __rest(_a, ["children", "showLoader", "className", "loaderProps"]);
    return (jsx("div", Object.assign({ ref: ref, className: className }, htmlProperties, { children: showLoader ? (jsx("div", Object.assign({ className: styles$1.loaderContainer }, { children: jsx(Loader, Object.assign({}, loaderProps)) }))) : (children) })));
});

var css_248z = ".success-modal-module_successModal__-49g- {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  font-family: var(--phx-fontFamily, Lato, sans-serif);\n  width: var(--phx-deleteAccountSuccessModalWidth, 360px);\n  padding: var(--phx-deleteAccountSuccessModalPadding, 36px 40px 30px);\n}\n\n.success-modal-module_headline__Hhnf9,\n.success-modal-module_body__fS3Cc {\n  width: 100%;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN1Y2Nlc3MtbW9kYWwubW9kdWxlLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxhQUFhO0VBQ2IsbUJBQW1CO0VBQ25CLHNCQUFzQjtFQUN0QixvREFBb0Q7RUFDcEQsdURBQXVEO0VBQ3ZELG9FQUFvRTtBQUN0RTs7QUFFQTs7RUFFRSxXQUFXO0FBQ2IiLCJmaWxlIjoic3VjY2Vzcy1tb2RhbC5tb2R1bGUuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5zdWNjZXNzTW9kYWwge1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBmb250LWZhbWlseTogdmFyKC0tcGh4LWZvbnRGYW1pbHksIExhdG8sIHNhbnMtc2VyaWYpO1xuICB3aWR0aDogdmFyKC0tcGh4LWRlbGV0ZUFjY291bnRTdWNjZXNzTW9kYWxXaWR0aCwgMzYwcHgpO1xuICBwYWRkaW5nOiB2YXIoLS1waHgtZGVsZXRlQWNjb3VudFN1Y2Nlc3NNb2RhbFBhZGRpbmcsIDM2cHggNDBweCAzMHB4KTtcbn1cblxuLmhlYWRsaW5lLFxuLmJvZHkge1xuICB3aWR0aDogMTAwJTtcbn0iXX0= */";
var styles = {"successModal":"success-modal-module_successModal__-49g-","headline":"success-modal-module_headline__Hhnf9","body":"success-modal-module_body__fS3Cc"};
styleInject(css_248z);

const SuccessModal = ({ isShowing, title, body, closeButtonLabel, onClose, }) => (jsx(Modal, Object.assign({ disableOnClickClose: true, isShowing: isShowing, close: onClose }, { children: jsxs("div", Object.assign({ className: styles.successModal }, { children: [jsx(Typography, Object.assign({ variant: "title" }, { children: title })), jsx(Typography, Object.assign({ variant: "body1", className: styles.body }, { children: body })), jsx(Button, Object.assign({ className: styles.button, variant: "primary", type: "button", onClick: onClose }, { children: closeButtonLabel }))] })) })));

export { ContainerWithLoader, SuccessModal };
